import { Flex, Button, FormControl, FormLabel, Input, Stack, useToast, Text, Alert, AlertIcon,FormErrorMessage } from '@chakra-ui/react'
import { useForm, Controller } from "react-hook-form";
import { findQueueByFullName, QueueUpdateForm } from '../../classes/Queue'
import { InputTelephoneNumber, Table } from '../shared';
import { BsSearch } from "react-icons/bs";
import { toastErrDesc, toastVal } from '../../utils/toastUtils';
import { useLoadingContext } from '../../context/loadingContext';
import { useMemo } from 'react';
import { hideInfo, HIDEINFO_EMAIL, HIDEINFO_TEL } from '../../utils/formatUtils'
import TableButtonUpdateContactGroup from '../shared/TableButtonUpdateContactGroup';
import { defaultQueueUpdateFormValue, useFormUpdateContactContext } from '../../context/formUpdateContactContext'

const TableUpdateQueueContact = ({ data }) => {
    // console.log(data)
    const columns = useMemo(() => [
        {
            Header: '#',
            Cell: ({ row }) => (<Text>{row.index + 1}</Text>)
        },
        {
            Header: "ชื่อ",
            accessor: 'first_name'
        },
        {
            Header: "นามสกุล",
            accessor: 'last_name'
        },
        {
            Header: "อาคาร",
            accessor: 'residence_short_name'
        },
        {
            Header: "วันที่ยื่น",
            accessor: 'submit_date'
        },
        {
            Header: "โทร",
            Cell: ({ row }) => (<Text>{hideInfo(row.original.tel, HIDEINFO_TEL)}</Text>)
        },
        {
            Header: "อีเมล",
            Cell: ({ row }) => (<Text>{hideInfo(row.original.email, HIDEINFO_EMAIL)}</Text>)
        },
        {
            Header: "จัดการ",
            Cell: ({ row }) => (<TableButtonUpdateContactGroup row={row}/>)
        }
    ], [])

    const { updateContactData: { form } } = useFormUpdateContactContext()

    // console.log(data)
    return (
        data != null &&
        <Flex mt={5} direction="column">
            <Text mb={1} color="red">ผลลัพธ์การตรวจสอบ พบคิวจำนวน {data.length} รายการ</Text>
            <Alert status='info' mb={4}>
                <AlertIcon />
                <Flex direction="column">
                    <Flex><Text fontWeight="bold" mr={2}>คำแนะนำ</Text> ท่านสามารถกดปุ่ม <Text fontWeight="bold" mx={2} backgroundColor="yellow.200" px={2} borderRadius="md">ปรับปรุง</Text> เพื่อแก้ไขข้อมูลติดต่อเป็นรายคิวได้</Flex>
                    <Flex>(ข้อมูลที่ปรับปรุง อีเมล : <Text fontWeight="bold" mx={2}>{form.email}</Text> โทร : <Text fontWeight="bold" mx={2}>{form.tel}</Text>)</Flex>
                </Flex>
     
            </Alert>
            <Table columns={columns} data={data} />
        </Flex>

    )
}


const FormUpdateContact = () => {

    const { control, handleSubmit,formState: { errors }, setError } = useForm()
    // const [data, setData] = useState(null)
    const { onModalClose, onModalOpen } = useLoadingContext()
    const toast = useToast()
    const { updateContactData, setUpdateContact } = useFormUpdateContactContext()
    // console.log(updateContactData)
    const onSubmit = async (data) => {
       
        // setData(null)
        // console.log(data)
        if (data.update_name) {
            data.tel = data.tel?.replaceAll(" ", "").replaceAll("_", "")
            if(data.tel.length !== 10){
                setError("tel", { type: 'invalid', message: 'รูปแบบหมายเลขโทรศัพท์ไม่ถูกต้อง' }, {shouldFocus: true})
                return;
            } 

            onModalOpen()
            const query1 = `?fname=${data.update_name}&lname=${data.update_lastname}`
            await findQueueByFullName(query1)
                .then(res => {
                    onModalClose()
                    if (res.length > 0) {
                        // console.log(res)
                        setUpdateContact({ form: new QueueUpdateForm(data), data: res })
                        // setData(res)
                    } else {
                        toast(toastVal({
                            title: "ไม่พบข้อมูลลำดับคิวของท่าน",
                            description: `ค้นด้วยชื่อ ${data.update_name} ${data.update_lastname}`,
                            status: "error",
                        }))
                    }
                })
                .catch(err => {
                    onModalClose()
                    // console.log(err)
                    setUpdateContact(defaultQueueUpdateFormValue)
                    toast(toastVal({
                        title: "การตรวจสอบ ไม่สำเร็จ",
                        description: toastErrDesc(err),
                        status: "error",
                    }))
                })
        } else {
            setUpdateContact(defaultQueueUpdateFormValue)
        }
    }

    return (
        <Flex w={{ base: "full", md: "80%" }} direction="column" mt={5} >
            <form onSubmit={handleSubmit(onSubmit)}>
                <Stack direction={{ base: "column", lg: "row" }}>
                    <FormControl isRequired  isInvalid={errors.update_name}>
                        <FormLabel>ชื่อ</FormLabel>
                        <Controller
                            name="update_name"
                            control={control}
                            rules={{ required: true }}
                            render={({ field }) => <Input type="text" maxLength={100} placeholder="กรอกชื่อ" {...field} />}
                        />
                        <FormErrorMessage>กรุณากรอกชื่อ</FormErrorMessage>
                    </FormControl>
                    <FormControl isRequired  isInvalid={errors.update_lastname}>
                        <FormLabel>นามสกุล</FormLabel>
                        <Controller
                            name="update_lastname"
                            control={control}
                            rules={{ required: true }}
                            render={({ field }) => <Input type="text" maxLength={100} placeholder="กรอกนามสกุล" {...field} />}
                        />
                        <FormErrorMessage>กรุณากรอกนามสกุล</FormErrorMessage>
                    </FormControl>
                </Stack>
                <Stack direction={{ base: "column", md: "row" }} mt={2}>
                    <FormControl isRequired  isInvalid={errors.email}>
                        <FormLabel>อีเมล</FormLabel>
                        <Controller
                            name="email"
                            control={control}
                            rules={{ pattern: /^\S+@\S+$/i, required: true}}
                            render={({ field }) => <Input type="text" maxLength={100} placeholder="กรอกอีเมล" {...field} />}
                        />
                        <FormErrorMessage>รูปแบบอีเมลไม่ถูกต้อง</FormErrorMessage>
                    </FormControl>
                    <FormControl isRequired isInvalid={errors.tel}>
                        <FormLabel>หมายเลขโทรศัพท์มือถือ</FormLabel>
                        <InputTelephoneNumber control={control} />
                        <FormErrorMessage>{errors.tel?.message || "กรอกหมายเลขโทรศัพท์"}</FormErrorMessage>
                    </FormControl>
                </Stack>
                <Flex w="full" mt={5} justify="center">
                    <Button type="submit" colorScheme='green' w={{ base: "full", lg: "30%" }} leftIcon={<BsSearch />}>ตรวจสอบ</Button>
                </Flex>
            </form>
            <TableUpdateQueueContact data={updateContactData.data} />
        </Flex>
    )
}

export default FormUpdateContact